import { sha256 } from 'js-sha256';

import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import request from './request';
import { IBaseResponse, IResult } from './types/common';
import {
  IEmailToCustomerParams,
  IGetUserSecurityParams,
  IPostSecurityParams,
  ISendEmailParams,
  ISendSmsParams,
} from './types/googleUnbind';

const IS_UNDER_REVIEW = `${API2_HOST}/v3/public/unbind-google-2fa/audit-status`;
const GET_USER_SECURITY = `${API2_HOST}/v3/public/unbind-google-2fa/safety-items`;
const POST_SECURITY = `${API2_HOST}/v3/public/unbind-google-2fa/commit`;
const SEND_SMS = `${API2_HOST}/v3/public/unbind-google-2fa/send-code-to-mobile`;
const SEND_EMAIL = `${API2_HOST}/v3/public/unbind-google-2fa/send-code-to-email`;
const EMAIL_TO_CUSTOMER = `${API2_HOST}/v3/public/unbind-google-2fa/send-email-to-salesforce`;

// 解绑谷歌验证码。
// export function unbind(code: string, password: string) {
export function unbind(risk_token: string) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/google2fa/unbind`;
    fetchData
      .post(url, {
        body: JSON.stringify({ risk_token }),
      })
      .then((response: any) => {
        resolve(response.result);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
}
// 判断用户是否处于审核中
export function isUnderReview(params: any) {
  return request.get<IBaseResponse<any>>(IS_UNDER_REVIEW, {
    useCache: true,
    body: JSON.stringify(params),
  });
}

// 获取用户安全项，邮箱、手机
export function getUserSecurity(params: IGetUserSecurityParams) {
  return fetchData.get<IBaseResponse<any>>(GET_USER_SECURITY, {
    body: JSON.stringify(params),
  });
}

// 提交用户输入的安全项验证码
export function postSecurity(params: IPostSecurityParams) {
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(POST_SECURITY, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 请求发送短信验证码
export function sendSms(params: ISendSmsParams) {
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(SEND_SMS, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 请求发送邮箱验证码
export function sendEmail(params: ISendEmailParams) {
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(SEND_EMAIL, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 提交客服工单
export function emailToCustomer(params: IEmailToCustomerParams) {
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(EMAIL_TO_CUSTOMER, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}
